import Spinner from '@carvana/ds-spinner';
import { useEffect, useState } from 'react';
import { SortedArticle } from '~/contracts/flp/Article';
import getArticles from '~/services/flp/getArticles';
import AccordionPanel from './AccordionPanel';

type OwnProps = {
  page: string;
  urls: Map<string, number>;
};

export default function Articles({ page, urls }: OwnProps) {
  const [articles, setArticles] = useState<SortedArticle[]>([]);
  const [isError, setIsError] = useState(false);
  const isLoading = articles.length === 0 && !isError;

  useEffect(() => {
    getArticles(Array.from(urls.keys()))
      .then(articleData => {
        if ('error' in articleData) {
          setIsError(true);
          return;
        }
        const list = articleData.content || [];
        const sorted = list.sort((a, b) => {
          const idxA = urls.get(a.article_url) ?? 0;
          const idxB = urls.get(b.article_url) ?? 0;

          return idxA - idxB;
        });
        const data = sorted.map(a => ({
          content: a.article_content || '',
          heading: a.article_name,
          key: a.uid
        }));
        setArticles(data);
      })
      .catch(() => {
        setIsError(true);
      });
  }, [urls]);

  return isLoading ? (
    <div
      className="flex h-[438px] items-center justify-center"
      data-testid="articles-loading-shimmer"
    >
      <Spinner size={57} />
    </div>
  ) : (
    articles.map(d => <AccordionPanel key={d.key} data={d} page={page} />)
  );
}
